<div class="flex w-full px-5 py-2.5 chat-error absolute left-0" [class.bottom-0]="position === 'bottom'" [class.top-0]="position === 'top'">
  {{ error?.message | transloco: error?.data }}
</div>
